import { Navigate, Outlet, useLocation } from "react-router-dom";

import useUserStore from "../stores/User";
import { userHasBenefit } from "../utils/Benefits";

const AuthGuard = () => {
  const isUserLoggedIn = useUserStore((state) => state.isLoggedIn());
  const userData = useUserStore((state) => state.data);
  const loading = useUserStore((state) => state.loading);
  const location = useLocation();

  // Wait for user data to finish loading before redirecting
  if (loading) {
    return null;
  }

  if (isUserLoggedIn) {
    // Feature admins are allowed in so they can reach the Featured tab; the
    // dashboard itself hides every other tab from them.
    if (location.pathname.includes("admin") && !userData.isApprover && !userData.isFeatureAdmin) {
      //User is not an admin, redirect to database page
      return <Navigate to="/Database" replace />;
    }

    if (location.pathname.includes("indexerDashboard") && !userData.isIndexer && !userData.isApprover) {
      //User is not an indexer, redirect to database page
      return <Navigate to="/Database" replace />;
    }

    if (location.pathname.includes("platinumDatabase") && !userHasBenefit(userData, "platinumAccess") && !userData.isApprover) {
      // Uses the live platinumAccess benefit, not the unused isPlatinum column.
      return <Navigate to="/Database" replace />;
    }

    if (location.pathname.includes("curators") && !userData.isCurator && !userData.isApprover) {
      //User is not a Curator, redirect to database page
      return <Navigate to="/Database" replace />;
    }

    if (location.pathname.includes("roulette") && !userData.isApprover && !userHasBenefit(userData, "roulette")) {
      // Uses the live roulette benefit. Admins always allowed.
      return <Navigate to="/Database" replace />;
    }

    //Show the requested page
    return <Outlet />;
  }

  // A plain script link may point at a featured script, which logged-out visitors
  // are allowed to read. Hand those off to the public page, which bounces back
  // here (via ?from=database) if the script turns out not to be featured — so
  // links to the other ~27,000 scripts still land on the login prompt as before.
  const featuredCandidate = location.pathname.match(/^\/database\/script\/([^/]+)$/i);
  if (featuredCandidate) {
    return <Navigate to={`/featured/${featuredCandidate[1]}?from=database`} replace />;
  }

  //User is not logged in, redirect to login page
  return <Navigate to={`/DatabaseLogin?redirectTo=${location.pathname + location.search}`} replace />;
};

export default AuthGuard;
